<template>
    <el-dialog
        :visible="ticketDialogVisible"
        width="27rem"
        align="left"
        top="2.5%"
        :style="{height: '95%'}"
        class="ticketDialog"
        @close="closeDialog"
        @visible-change="closeDialog"
        v-on:update:visible="closeDialog"
          >
        <span class="monospace p-0" v-html="ticketCode"></span>
             
    </el-dialog>
</template>

<script>
export default {
    props: {
        ticketDialogVisible : {
            required: true,
            default: false
        },
        ticketCode : {
            required: true
        },
    },
    methods: {
        closeDialog(){
            this.$emit("close");
        },
    },
}
</script>

<style scoped>
.monospace {
  font-family: 'IBM Plex Mono', monospace;
  font-weight: 500;
  font-size: 16px;
}

.el-dialog__body {
  padding: 0 20px;
}

.ticketDialog .el-dialog .el-dialog__body{
  padding: 0 !important;
}
</style>